import { render, staticRenderFns } from "./AddAudience.vue?vue&type=template&id=79eda3b4&scoped=true&"
import script from "./AddAudience.vue?vue&type=script&lang=ts&"
export * from "./AddAudience.vue?vue&type=script&lang=ts&"
import style0 from "./AddAudience.vue?vue&type=style&index=0&id=79eda3b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eda3b4",
  null
  
)

export default component.exports